export default "__VITE_ASSET__CkI6Odxj__"